import {Box, Checkbox} from '@primer/react'
import type {BetterSystemStyleObject} from '@primer/react/lib-esm/sx'
import {useListViewVariant} from '../ListView/VariantContext'
import {useListItemSelection} from './SelectionContext'
import {useListItemTitle} from './TitleContext'
import {testIdProps} from '@github-ui/test-id-props'
import {useListViewSelection} from '../ListView/SelectionContext'

const containerSx: BetterSystemStyleObject = {
  width: 32,
  ml: 2,
  display: 'flex',
  justifyContent: 'center',
  gridArea: 'selection',
}

export const Selection = () => {
  const {variant} = useListViewVariant()
  const {isSelectable} = useListViewSelection()
  const {isSelected, onSelect} = useListItemSelection()
  const {title} = useListItemTitle()

  if (!isSelectable) return null

  return (
    <Box sx={containerSx} {...testIdProps('listview-item-selection')}>
      <Checkbox
        sx={{marginTop: variant === 'default' ? '14px' : '10px'}}
        checked={isSelected}
        onChange={() => onSelect(!isSelected)}
        aria-label={`Select: ${title}`}
      />
    </Box>
  )
}

try{ Selection.displayName ||= 'Selection' } catch {}